import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { AuthProvider } from "./contexts/AuthContext";
import { UserInfoProvider } from "./contexts/userInfo";
import { Subscript } from "@mui/icons-material";
import { SubscriptionsProvider } from "./contexts/subscriptionsContext";
import { NotificationProvider } from "./contexts/NotificationContext";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <AuthProvider>
    <UserInfoProvider>
      <SubscriptionsProvider>
        <NotificationProvider>
          <App />
        </NotificationProvider>
      </SubscriptionsProvider>
    </UserInfoProvider>
  </AuthProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
